export default "/images/framework/Forward.31c1bf67.svg?31c1bf67";